import TwinTableIconColumn from './twinTableIconColumn.vue';
import get from 'lodash/get';
import twinFields from '../twinFields';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { createNestedDashboardParameters } from '@/utils/dashboard-utils';
const {
  getDefinitions: getTwinFields
} = twinFields;
export default {
  name: 'TwinTable',
  components: {
    TwinTableIconColumn
  },
  props: {
    widget: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    dateRange: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('dashboards', ['dashboards']),
    completeWidget() {
      const clone = cloneDeep(this.widget);
      if (!clone.twinTableOptions) {
        clone.twinTableOptions = {
          columns: []
        };
      }
      if (!clone.twinTableOptions.columns) {
        clone.twinTableOptions.columns = [];
      }
      if (clone.nestedDashboard) {
        if (!clone.nestedDashboard.parameters) {
          clone.nestedDashboard.parameters = {};
        }
      }
      return clone;
    },
    twinFields() {
      return getTwinFields(this.$t, this.twins);
    },
    twins() {
      if (!this.data) {
        return [];
      }
      return this.data['twin-table'] || [];
    },
    columns() {
      return Array.isArray(this.completeWidget.twinTableOptions.columns) ? this.completeWidget.twinTableOptions.columns : [];
    },
    items() {
      return this.twins.map(twin => {
        const item = Object.fromEntries(this.columns.map((column, columnIndex) => {
          const fieldDefinition = get(this.twinFields, `['${column.property}']`);
          let value = '';
          if (column.property.startsWith('state.')) {
            const stateKey = column.property.replace('state.', '');
            const histories = get(twin, `_states['${stateKey}'].history.histories`, []);
            const sortedHistories = [...histories].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            const latestHistoryItem = sortedHistories[0];
            value = get(latestHistoryItem, 'value', '');
          } else if (fieldDefinition) {
            value = get(twin, fieldDefinition.key);
          } else {
            console.warn(`No field definition found for property: ${column.property}`);
            value = column.property;
          }
          if (typeof get(fieldDefinition, 'transformer') === 'function') {
            value = fieldDefinition.transformer(value);
          }
          return [`${columnIndex}-${column.property}`, value];
        }));
        item.__twin_id__ = twin.id;
        return item;
      });
    },
    headers() {
      return this.columns.map((column, columnIndex) => {
        const fieldDefinition = get(this.twinFields, `['${column.property}']`);
        let label = column.label;
        if (column.property.startsWith('state.')) {
          const stateKey = column.property.replace('state.', '');
          label = label || stateKey;
        } else if (fieldDefinition) {
          label = label || fieldDefinition.defaultLabel;
        }
        let width = column.width || undefined;
        if (!Number.isNaN(Number(width))) {
          width = `${width}px`;
        }
        return {
          text: label,
          value: `${columnIndex}-${column.property}`,
          component: get(fieldDefinition, 'component', 'string'),
          sortable: column.sortOrder !== 'disabled',
          defaultSortOrder: column.sortOrder,
          width
        };
      });
    },
    itemsPerPageOptions() {
      return [5, 10, 25, 50, this.completeWidget.twinTableOptions.rowsPerPage].filter((option, index, self) => self.indexOf(option) === index).sort((a, b) => a - b);
    },
    tableOptions() {
      const sortBy = [];
      const sortDesc = [];
      this.headers.forEach(header => {
        if (header.defaultSortOrder === 'disabled') {
          return;
        }
        if (!header.defaultSortOrder) {
          return;
        }
        sortBy.push(header.value);
        sortDesc.push(header.defaultSortOrder === 'desc');
      });
      return {
        sortBy,
        sortDesc
      };
    }
  },
  watch: {
    'completeWidget.nestedDashboard.dashboardId': {
      handler(nestedDashboardId) {
        if (!nestedDashboardId) {
          return;
        }
        this.$store.dispatch('dashboards/refreshOne', {
          dashboardId: nestedDashboardId
        });
      },
      immediate: true
    }
  },
  methods: {
    getByKey(obj, key) {
      return get(obj, key);
    },
    rowHasClickHandler(_item) {
      if (!_item) {
        return {
          isTrue: false
        };
      }
      if (this.editMode) {
        return {
          isTrue: false
        };
      }
      const nestedDashboardId = get(this.completeWidget, 'nestedDashboard.dashboardId');
      if (!nestedDashboardId) {
        return {
          isTrue: false
        };
      }
      const nestedDashboard = this.dashboards.find(dashboard => dashboard.id === nestedDashboardId);
      if (!nestedDashboard) {
        console.error(`Nested dashboard with id ${nestedDashboardId} not found`);
        this.$snack(this.$t('Dashboards.components.twinTable.error.nestedDashboardNotFound'), 'error');
        return {
          isTrue: false
        };
      }
      return {
        isTrue: true,
        data: {
          nestedDashboard
        }
      };
    },
    onRowClick(item) {
      const {
        isTrue: hasRowClickHandler,
        data
      } = this.rowHasClickHandler(item);
      if (!hasRowClickHandler) {
        return;
      }
      const twin = this.twins.find(twin => twin.id === item.__twin_id__);
      const nestedDashboard = data.nestedDashboard;
      const nestedDashboardParameters = createNestedDashboardParameters(nestedDashboard, this.completeWidget.nestedDashboard.parameters, this.customParameters, twin);
      this.$emit('activate-sub-dashboard', {
        dashboardId: nestedDashboard.id,
        customParameters: nestedDashboardParameters,
        navigationType: this.completeWidget.nestedDashboard.navigationType
      });
    }
  }
};